import Icon from '../components/Icon.vue'

Icon.register({"upload":{"width":512,"height":512,"paths":[{"d":"M296 384H216C202.7 384 192 373.3 192 360V192H104.3C86.5 192 77.6 170.5 90.2 157.9L242.3 5.7C249.8-1.8 262.1-1.8 269.6 5.7L421.8 157.9C434.4 170.5 425.5 192 407.7 192H320V360C320 373.3 309.3 384 296 384zM512 376V488C512 501.3 501.3 512 488 512H24C10.7 512 0 501.3 0 488V376C0 362.7 10.7 352 24 352H160V360C160 390.9 185.1 416 216 416H296C326.9 416 352 390.9 352 360V352H488C501.3 352 512 362.7 512 376zM388 464C388 453 379 444 368 444S348 453 348 464 357 484 368 484 388 475 388 464zM452 464C452 453 443 444 432 444S412 453 412 464 421 484 432 484 452 475 452 464z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/upload.js
// module id = null
// module chunks = 